<template>
  <div class="row inline no-wrap q-pa-sm" :class="`bg-${backgroundColor}`">
    <QIcon :name="icon" :color="iconColor" size="18px" class="q-mr-sm" />
    <span class="sai-tip-text">{{ text }}</span>
  </div>
</template>

<script>
import { QIcon } from 'quasar';
export default {
  name: 'SAITip',
  props: {
    backgroundColor: {
      type: String,
      default: 'tip-light'
    },
    icon: {
      type: String,
      default: 'eva-bell-outline'
    },
    iconColor: {
      type: String,
      default: 'tip'
    },
    text: {
      type: String,
      required: true
    }
  },
  components: {
    QIcon
  }
};
</script>
<style lang="sass" scoped>
.sai-tip-text
  font-size: 12px
  line-height: 18px
  letter-spacing: .2px
</style>
